// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Fetch = require("bs-fetch/src/Fetch.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.bs.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.bs.js");
var Util$SmartcutsMacros = require("../../packages/bs-utils/src/Util.bs.js");
var PromiseUtils$SmartcutsMacros = require("../../packages/bs-utils/src/PromiseUtils.bs.js");

function manageSubscription(stripeCustomerId, router) {
  fetch("/api/stripe/portal", Fetch.RequestInit.make(/* Post */2, Caml_option.some(Js_dict.fromArray([[
                          "Content-type",
                          "application/json"
                        ]])), Caml_option.some(JSON.stringify(Json_encode.object_({
                            hd: [
                              "customer",
                              stripeCustomerId
                            ],
                            tl: /* [] */0
                          }))), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined)).then(function (response) {
        var statusCode = response.status;
        if (statusCode === 200) {
          return PromiseUtils$SmartcutsMacros.resolveWith((function (json) {
                        var redirectUrl = Json_decode.field("url", Json_decode.string, json);
                        router.push(redirectUrl, undefined, undefined);
                        
                      }), response.json());
        } else if (statusCode >= 400 || statusCode < 200) {
          return Util$SmartcutsMacros.logAndRaiseJsError("Unexpcted statusCode " + String(statusCode));
        } else {
          return Promise.resolve(undefined);
        }
      });
  
}

exports.manageSubscription = manageSubscription;
/* Util-SmartcutsMacros Not a pure module */
